import APIClient from '@/shared/http/clients/api'

const resourceName = 'movimentacao'
const APICore = process.env.APIBaseURLCore

const GetAll = (filter = {}, limit, index, config = {}) => APIClient.get(`${APICore}/${resourceName}/associados/?${filter}&hasNotGR=true&page=${index}&size=${limit}&sort=pessoa.nome,desc`, config)

const MovimentationRepository = {
  GetAll
}

export default MovimentationRepository



// WEBPACK FOOTER //
// ./src/shared/http/repositories/configurations/movimentation.js